module.exports = __webpack_public_path__ + "img/home-background.c6f48b8b.png";